import React from "react";
import successimage from "../../assets/Images/modalerrorimage.svg";
import { Box, Modal } from "@mui/material";
import styles from "./NomineeDeclarationModal.module.scss";
import infoicon from "../../../Components/assets/Images/infoicon.svg"

const successModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "10px",
  boxShadow: 24,
  outline: "none",
  display: "flex",
};

interface props {
  openModal: boolean;
  handleClose: any;
  handleSubmit:any;
}

const NomineeDeclarationModal = ({ openModal, handleClose,handleSubmit }: props) => {
  return (
    <Modal
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      open={openModal}
      slotProps={{
        backdrop: {
          timeout: 100,
        },
      }}
      BackdropProps={{
        style: {
          background: "rgba(31, 41, 55, 0.30)",
          backdropFilter: "blur(3px)",
          WebkitBackdropFilter: "blur(3px)",
        },
        timeout: 100,
      }}
    >
      <Box sx={successModalStyles}>
        <div className={styles.modalWrapper}>
          <p className={styles.title}>{"Declaration"}</p>
          <p className={styles.desc}>
            I hereby declare that I do not wish to nominate any person for my
            trading and demat account at this time. I understand that I have the
            option to add a nominee at a later date
          </p>
          <div className={styles.infosection}>
          <img src={infoicon} />  Keep your Aadhaar ready to proceed
          </div>
          <div className={styles.cancelButtonsSection}>
            <div className={styles.cancel} onClick={handleClose}>
              Cancel
            </div>
            <div className={styles.submit} onClick={handleSubmit}>
              Agree & E-Sign
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default NomineeDeclarationModal;
